import { map } from 'lodash';
import { createAction } from 'redux-actions';
import { CALL_API } from '../constants';
import { fromAddressResponse } from '../util';

const toPharmacy = ({ address, pharmacist, ...pharmacy }) => {
  return {
    ...fromAddressResponse(address),
    id: pharmacy.id,
    email: pharmacy.email,
    fax: pharmacy.fax,
    firstName: pharmacist.firstName,
    lastName: pharmacist.lastName,
    notes: pharmacy.notes,
    pharmacyName: pharmacy.name,
    pharmacistId: pharmacist.id,
    phoneExtension: pharmacy.extension,
    primaryPhoneNumber: pharmacy.phone,
  };
};

const PharmaciesService = {
  getByPatientId: createAction(CALL_API, patientId => ({
    method: 'GET',
    path: `/pharmacies/patient/${patientId}`,
    handleResponse: pharmacies => map(pharmacies, toPharmacy),
    handleError: () =>
      Promise.reject(
        'We were unable to load your pharmacy information. Please refresh the page to try again.',
      ),
  })),

  create: createAction(CALL_API, pharmacies => ({
    body: pharmacies,
    method: 'POST',
    path: '/pharmacies/bulk',
    handleError: () =>
      Promise.reject('Something went wrong. Please try again.'),
  })),
};

export default PharmaciesService;



// WEBPACK FOOTER //
// ./src/lib/dataLayer/pharmacies/PharmaciesService.js